import React, { useState } from "react";
import { Box, Typography, RadioGroup, FormControlLabel, Radio, Button, Link, Paper ,Divider , Stack, Chip} from "@mui/material";
import RazorPayButton from "../RazorPay/RazorPayButton";

const PaymentForm = ({ active, subscriptionPlan, customer , userData, start_at }) => {
  if (!active) {
    return (
      <Paper sx={{ p: 4, borderRadius: 2 }}>
        <Typography variant="h3" fontWeight="bold" gutterBottom>Payment</Typography>
      </Paper>
    )
  }
  const startDate = start_at ? new Date(start_at * 1000) : new Date();
  const endDate = new Date(startDate);
  const { durationType, durationValue } = subscriptionPlan || {};

  if (durationType === "month") {
     endDate.setMonth(endDate.getMonth() + (durationValue || 0));  
  }

  if (durationType === "year") {
    endDate.setFullYear(endDate.getFullYear() + (durationValue || 0));  
  }  

  const formatDate = (date) => {
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };
  return (
    <>
    {/* <Paper sx={{p:4 , borderRadius: 2}}> */}
      <Box sx={{ mb: 3 }}>
        <Box sx={{ display: "flex", flexDirection:"column", my: 1 }}>
          <Typography variant="body1" > {userData.firstName}{userData.lastName} </Typography>
          <Typography variant="body1">{userData.email}</Typography>
        </Box>
        <Box sx={{ display: "flex", justifyContent: "space-between", my: 1 }}>
          <Typography variant="body1" color="primary" fontWeight="bold">Subscription Start From:</Typography>
          <Typography variant="body1">{formatDate(startDate)}</Typography>
        </Box>

        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Typography variant="body1" color="primary" fontWeight="bold">Subscription Expiry On:</Typography>
          <Typography variant="body1">{formatDate(endDate)}</Typography>
        </Box>
      </Box>
      {/* <Typography variant="h4" color="info">Please click Pay now to proceed with payment </Typography> */}
      <Divider sx={{ my: 2 }} />    
      <RazorPayButton subscriptionPlan={subscriptionPlan} customer={customer} userData={userData} start_at ={start_at} />
    {/* </Paper> */}
    </>
  );
};

export default PaymentForm;
